import { INPUT_TYPES } from '../utils/constants.js';
function createControlsOptions(name, defaultValue = true) {
    return {
        [`behaviourParams_item_threeDimensionalScene_controls_enable${name}`]: {
            title: `3D Scene ${name} control`,
            isRelevant: () => true,
            type: INPUT_TYPES.BOOLEAN,
            description: `Set 3D item ${name} control to be enabled or disabled`,
            default: defaultValue,
        },
    };
}
export default Object.assign(Object.assign(Object.assign(Object.assign({}, createControlsOptions('Zoom', false)), createControlsOptions('Pan')), createControlsOptions('Rotate')), createControlsOptions('AutoRotate'));
//# sourceMappingURL=behaviourParams_item_threeDimensionalScene_controls.js.map